import axios from 'axios';
import { BASEURL } from '../../utilites';
import { TAXPRO_NOTES_ACTION_TYPE } from './Type';

const cacheKey = (taxproUserId, type) =>
	`${taxproUserId}:${type === undefined || type === null ? 'all' : type}`;

const listNotes = (taxproUserId, type) => {
	return async (dispatch) => {
		if (!taxproUserId) return;
		const key = cacheKey(taxproUserId, type);
		dispatch({
			type: TAXPRO_NOTES_ACTION_TYPE.setLoading,
			payload: { key, loading: true },
		});
		try {
			const params = { taxpro_user_id: taxproUserId };
			if (type !== undefined && type !== null) params.type = type;
			const res = await axios.get(`${BASEURL}/api/taxpro-notes`, { params });
			const data = res?.data?.data || {};
			dispatch({
				type: TAXPRO_NOTES_ACTION_TYPE.setNotes,
				payload: {
					key,
					notes: data.notes || [],
					total: data.total || 0,
				},
			});
			return { success: true, notes: data.notes || [] };
		} catch (err) {
			const message =
				err?.response?.data?.error || err?.message || 'Failed to load notes';
			dispatch({
				type: TAXPRO_NOTES_ACTION_TYPE.setError,
				payload: { key, error: message },
			});
			return { success: false, error: message };
		}
	};
};

const createNote = ({ taxproUserId, type, note, metadata }) => {
	return async (dispatch) => {
		try {
			const res = await axios.post(`${BASEURL}/api/taxpro-notes`, {
				taxpro_user_id: taxproUserId,
				type,
				note,
				metadata,
			});
			const created = res?.data?.data?.note;
			// Refresh every cache the modal might be subscribed to: the specific
			// type and the "all types" view.
			await Promise.all([
				dispatch(listNotes(taxproUserId, type)),
				dispatch(listNotes(taxproUserId, null)),
			]);
			return { success: true, note: created };
		} catch (err) {
			const message =
				err?.response?.data?.error || err?.message || 'Failed to save note';
			return { success: false, error: message };
		}
	};
};

const updateNote = ({ id, note, metadata, taxproUserId, type }) => {
	return async (dispatch) => {
		try {
			const res = await axios.patch(`${BASEURL}/api/taxpro-notes/${id}`, {
				note,
				metadata,
			});
			const updated = res?.data?.data?.note;
			if (taxproUserId) {
				await dispatch(listNotes(taxproUserId, type));
			}
			return { success: true, note: updated };
		} catch (err) {
			const message =
				err?.response?.data?.error || err?.message || 'Failed to update note';
			return { success: false, error: message };
		}
	};
};

const clearNotes = (taxproUserId, type) => ({
	type: TAXPRO_NOTES_ACTION_TYPE.clearNotes,
	payload: { key: cacheKey(taxproUserId, type) },
});

export const taxproNotes = {
	listNotes,
	createNote,
	updateNote,
	clearNotes,
	cacheKey,
};
